import script from "./upvotes-counter.vue?vue&type=script&setup=true&lang=ts"
export * from "./upvotes-counter.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__